import React from "react";
import { Outlet } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import NavBar from "../navBar/NavBar";
import SideBar from "../sideBar/SideBar";
import "react-toastify/dist/ReactToastify.css";
import useSession from "../../../hooks/useSession";
import Loading from "../loading/Loading";

const Layout = () => {
  const [user, loading] = useSession();
  if (loading) {
    return <Loading />;
  }
  return (
    <div>
      <NavBar user={user} />
      <div className="flex flex-row">
        <div className="hidden lg:block w-[19rem]">
          <SideBar user={user} />
        </div>
        <div className="w-full ">
          <Outlet />
          <ToastContainer
            position="bottom-right"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="light"
          />
        </div>
      </div>
    </div>
  );
};

export default Layout;
